// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .k-widget.k-upload .k-action-buttons {
    display: none;
  }
`, "",{"version":3,"sources":["webpack://./src/app/cp/employees/training/employee-training.component.ts"],"names":[],"mappings":";EACE;IACE,aAAa;EACf","sourcesContent":["\n  .k-widget.k-upload .k-action-buttons {\n    display: none;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
